export default {"src":"/_next/static/media/FSLY.9c03d7c5.svg","height":18,"width":18};